/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PrimaryPayers/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function PrimaryPayers({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Insurance/AssignedInsurance/Content/AssignedInsuranceItem/InsuredTreatments/Content/InsuredTreatment/Content/Treatment/PrimaryPayers"
  
}) {
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let txsValueData = fromData.useDataFormat({ viewPath,
context: 'txs',
format: fromHelpers.getPrimaryCount,
})
  return (<React.Fragment
>
<div
  data-testid="PrimaryPayers.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral500}
 text="# of Primary payors:"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="txs"
 format="helpers.js getPrimaryCount"
 text={txsValueData}
/>
</div>
{children}
</React.Fragment>)
}